import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useUserDetailsQuery } from 'src/store/api/accounts/accountsApiSlice';
import { useDeliveryPricesQuery } from 'src/store/api/delivery/deliveryApiSlice';
import { checkoutSelector, setCheckoutDelivery } from 'src/store/reducers/checkout';
import { DeliveryItemType } from 'src/types/delivery/delivery';

export const findDeliveryForCity = (
    deliveries: DeliveryItemType[] | undefined,
    cityId: number | null | undefined,
): DeliveryItemType | null => {
    if (!Array.isArray(deliveries) || !cityId) return null;
    return deliveries.find((option) => option?.city?.id === cityId) ?? null;
};

/**
 * Preselects the signed-in customer's saved profile city as the delivery area
 * for this checkout. It only ever fills an empty selection, so a city the
 * customer picked by hand is never overwritten, and the write goes to the
 * checkout draft only — the profile is left untouched.
 */
const useDeliveryCityPreselect = () => {
    const dispatch = useDispatch();
    const { delivery } = useSelector(checkoutSelector);
    const { data: deliveries } = useDeliveryPricesQuery(undefined);
    const { data: profile } = useUserDetailsQuery(undefined);

    useEffect(() => {
        if (delivery) return;

        const match = findDeliveryForCity(
            Array.isArray(deliveries) ? deliveries : undefined,
            profile?.city?.id,
        );
        if (match) {
            dispatch(setCheckoutDelivery(match));
        }
    }, [deliveries, delivery, dispatch, profile?.city?.id]);
};

export default useDeliveryCityPreselect;
